import { Dialog } from "components/dialog/Dialog";
import { DialogFooter } from "components/dialog/DialogFooter/DialogFooter";
import { DialogHeader } from "components/dialog/DialogHeader/DialogHeader";
import { DialogBody } from "components/dialog/DialogMain/DialogBody/DialogBody";
import { DialogMain } from "components/dialog/DialogMain/DialogMain";
import { useDialogContext } from "components/dialog/controller/DialogProvider";

export const LogoutDialog = () => {
  const { dialogProps } = useDialogContext();
  return (
    <Dialog size="small" state="info">
      <DialogHeader>Message</DialogHeader>
      <DialogMain>
        <DialogBody>Are you sure you want to logout?</DialogBody>
      </DialogMain>
      <DialogFooter
        button={{
          label: "Logout",
          onClick: dialogProps.buttonClick,
        }}
      />
    </Dialog>
  );
};
